import { SvgDef, SvgWinnerBadge } from '../Svg/index';

import * as style from './style.module.scss';

const Winner = () => (
  <div data-testid='winner' className={style.winnerBadge}>
    <SvgDef></SvgDef>
    <SvgWinnerBadge></SvgWinnerBadge>
  </div>
);

export default Winner;
